import React from 'react';
import ReactDOM from 'react-dom/client';
import './root.css'
import './i18n/i18n'; 
import Home from './componets/pages/home';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <Home />
  </React.StrictMode>
);
